import * as types from "../constants/actionConstants";


const initialState = {
    name: ""
};


function integrationNameReducer(state = initialState, action) {
    switch (action.type) {
        case types.INTEGRATION_SET_NAME:
            return {
                ...state,
                name: action.name
            };
        default:
            return state;
    }
}

export default integrationNameReducer;